'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deriveDevelopersDomainFromUser;
function _hash(input) {
  var hash = 0;
  if (input.length === 0) {
    return hash;
  }
  for (var i = 0; i < input.length; i++) {
    var char = input.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return (hash >>> 0).toString(36);
}

function deriveDevelopersDomainFromUser(user) {
  var email = user.get('email');
  return 'hubspot-developers-' + _hash(email) + '.com';
}
module.exports = exports['default'];